<template>
  <b-container class="chat-box cm-shell">
    <b-row>
      <b-col cols="12" lg="10" class="mx-auto">
        <MaterialApplicationStep
          :style="{
            '--main-color': mainColor,
            '--secondary-color': secondaryColor,
            '--product-deep': '#3e175e',
            '--product-rgb': '145, 74, 207',
            '--product-soft': '#f7f0fc',
            '--product-line': '#e3d4f0',
          }"
          :context="context"
          initial-mode="class-material"
          :class-material-only="true"
          class="mb-4"
          @go-to-step="noop"
          @no-uses="noop"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import MaterialApplicationStep from "./MaterialApplicationStep.vue";

export default {
  name: "ChatbotMaterialesClase",
  components: { MaterialApplicationStep },
  props: {
    bannerLoaded: { type: Boolean, required: false, default: false },
    routeName: { type: String, required: false, default: "" },
    tags: { type: Array, required: false, default: () => [] },
  },
  data() {
    return {
      mainColor: "#914acf",
      secondaryColor: "#6f2da8",
      context: {
        service: "Materiales para la clase",
        productMode: "class-materials",
      },
    };
  },
  methods: {
    noop() {},
  },
};
</script>

<style scoped>
.cm-shell {
  --main-color: #914acf;
  --secondary-color: #6f2da8;
  --product-deep: #3e175e;
  --product-rgb: 145, 74, 207;
  --product-soft: #f7f0fc;
  --product-line: #e3d4f0;
  padding-top: 1rem;
  padding-bottom: 2rem;
}
</style>
